import { atom } from "recoil";

export const MemberListState = atom({
  key: "MemberListState",
  default: [],
});
